export const DrawerSizeOptions = {
  Third: 'Third',
  Half: 'Half',
  TwoThirds: 'TwoThirds',
  Full: 'Full',
  Middle: 'Middle',
  Popup: 'Popup',
  Static: 'Static'
}
